// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__Lm0U0","legacyBtn":"MutateMid_legacyBtn__3pLb6"};